import { useEffect, useReducer } from 'react'
import { wf } from '../outline/state.js'
import { ctx } from '../outline/ctx.js'
import { ItemNode } from './MilestoneSections.jsx'

function calcCatZoomVis() {
  return !!(wf.zoomCat && wf.zoomMsId && !wf.zoomItemId && !wf.searchQuery)
}

export default function CategoryZoom() {
  const [, forceUpdate] = useReducer(v => v + 1, 0)

  useEffect(() => {
    function onRender() { forceUpdate() }
    window.addEventListener('outline-render', onRender)
    return () => window.removeEventListener('outline-render', onRender)
  }, [])

  if (!calcCatZoomVis()) return null

  const msId = wf.zoomMsId
  const cat  = wf.zoomCat
  const items = ctx.clCache?.[msId]

  if (!items) {
    return (
      <div style={{ padding: 20, fontFamily: "'DM Sans',sans-serif", fontSize: 13, color: '#7a9aaa' }}>
        Loading...
      </div>
    )
  }

  const catNodes  = ctx.getCategoryNodes(msId, items)
  const catObj    = catNodes.find(c => c.cat === cat)
  const catItems  = catObj ? catObj.items : []

  return (
    <div className="wf-list">
      {catItems.map(item => (
        <ItemNode key={item.record.id} item={item} msId={msId} />
      ))}
    </div>
  )
}
